import { render, staticRenderFns } from "./AamsGiftRegPurchaseApproval.vue?vue&type=template&id=19a2fb44&scoped=true&"
import script from "./AamsGiftRegPurchaseApproval.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegPurchaseApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2fb44",
  null
  
)

export default component.exports